@use '../../../design-tokens/typography/typography' as *;

@layer design-system {
  .dropdownWrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;

    &:not(:last-child) {
      border-bottom: 1px solid var(--border-soft);
      padding-bottom: 4px;
    }

    &:not(:first-child) {
      padding-top: 4px;
    }
  }

  .dropdownGroup {
    display: flex;
    flex-direction: column;
    gap: 4px;
    @include typography-v2-body-xs;
    padding-left: 16px;
  }

  .dropdownMenuCheckboxItem {
    all: unset;
    @include typography-v2-body-sm;

    [data-checkbox-wrapper] {
      padding: 8px;
      padding-left: 16px;
    }

    &.multiselect [data-checkbox-wrapper] {
      padding-left: 8px;
    }
  }

  .label {
    color: var(--text-soft);
    padding: 2px 16px;
    text-transform: uppercase;
  }

  .dropdownCheckbox {
    label {
      width: 100%;
      align-items: center;

      [data-checkmark] {
        margin-top: 0;
      }
    }
  }
}
